import React, { useMemo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';

import safeLocalStorage from 'client/lib/safeLocalStorage';
import AuthActions from 'client/actions/Auth';
import useDispatch from 'client/hooks/useDispatch';
import useBranch from 'client/hooks/useBranch';

import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrBox from 'client/components/SrBox';
import SrFilterCheckbox from 'client/components/SrFilterCheckbox';

import { hasRoleAdmin } from 'common/userRoles';

const SrViewAsPartnerToggle = ({ partnerId }) => {
  const [isBusy, setIsBusy] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  const { currentUserRoles } = useBranch({
    currentUserRoles: ['currentUser', 'roles'],
  });

  const isActive = useMemo(() => {
    return (
      safeLocalStorage.getItem('srViewAsPartnerToggleActive') === 'true' &&
      !hasRoleAdmin(currentUserRoles)
    );
  }, [currentUserRoles]);

  const shouldShow = hasRoleAdmin(currentUserRoles) || isActive;

  const onToggle = useCallback(() => {
    if (isActive && !global.confirm('Are you sure you want to log out?')) {
      return;
    }

    setIsBusy(true);

    if (isActive) {
      safeLocalStorage.removeItem('srViewAsPartnerToggleActive');
      history.push('/logout');
    } else {
      safeLocalStorage.setItem('srViewAsPartnerToggleActive', 'true');
      dispatch(AuthActions.logonas, {
        partnerId,
      });
    }
  }, [dispatch, partnerId, isActive, history]);

  if (!shouldShow) {
    return null;
  }

  return (
    <div>
      <SrText font="greycliff" weight="500" size="12">
        View as Partner
      </SrText>
      <SrFlex>
        <SrFilterCheckbox
          className="green"
          value={isBusy ? !isActive : isActive}
          onChange={onToggle}
        />
        {isActive && (
          <SrBox marginTop="-1px" paddingLeft="6px">
            <SrText font="greycliff" weight="500" size="12" color="green">
              Active
            </SrText>
          </SrBox>
        )}
      </SrFlex>
    </div>
  );
};

SrViewAsPartnerToggle.displayName = 'SrViewAsPartnerToggle';

SrViewAsPartnerToggle.propTypes = {
  partnerId: PropTypes.number.isRequired,
};

export default SrViewAsPartnerToggle;
